import {
  CHANGE_SCENARIO_NAME,
  CHANGE_VALID,
  CHANGE_SUBMITTING,
  CHANGE_REQUESTING_NEXT,
  CHANGE_FETCHING,
  CHANGE_CALLING_NEXT_CALLBACK,
} from "features/budget/wizard/state/wizard.actions";

const INITIAL_STATE = {
  scenarioName: "",
  isValid: true,
  isSubmitting: false,
  isRequestingNext: false,
  isFetching: false,
  isCallingNextCallback: false,
};

// eslint-disable-next-line default-param-last
const wizardReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_SCENARIO_NAME:
      return {
        ...state,
        scenarioName: payload.scenarioName,
      };
    case CHANGE_VALID:
      return {
        ...state,
        isValid: payload.valid,
      };
    case CHANGE_SUBMITTING:
      return {
        ...state,
        isSubmitting: payload.submitting,
      };
    case CHANGE_REQUESTING_NEXT:
      return {
        ...state,
        isRequestingNext: payload.requestingNext,
      };
    case CHANGE_FETCHING:
      return {
        ...state,
        isFetching: payload.fetching,
      };
    case CHANGE_CALLING_NEXT_CALLBACK:
      return {
        ...state,
        isCallingNextCallback: payload.calling,
      };
    default:
      return state;
  }
};

export default wizardReducer;
